export function StatCard({ label, value, sub, icon: Icon, accent = "blue", testid }) {
  const accents = {
    blue: "bg-blue-50 text-blue-600", emerald: "bg-emerald-50 text-emerald-600",
    amber: "bg-amber-50 text-amber-600", violet: "bg-violet-50 text-violet-600",
    slate: "bg-slate-100 text-slate-600", rose: "bg-rose-50 text-rose-600",
  };
  return (
    <div data-testid={testid} className="rounded-xl border border-slate-200 bg-white p-5">
      <div className="flex items-center justify-between">
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">{label}</p>
        {Icon && <div className={`h-8 w-8 rounded-lg flex items-center justify-center ${accents[accent]}`}><Icon className="h-4 w-4" /></div>}
      </div>
      <p className="mt-2 font-heading text-2xl font-extrabold tracking-tight text-slate-900">{value}</p>
      {sub && <p className="text-xs text-slate-400 mt-1">{sub}</p>}
    </div>
  );
}

const STATUS_STYLES = {
  active: "bg-emerald-100 text-emerald-700", trialing: "bg-blue-100 text-blue-700",
  canceled: "bg-rose-100 text-rose-700", none: "bg-slate-100 text-slate-500",
  open: "bg-blue-100 text-blue-700", in_progress: "bg-amber-100 text-amber-700",
  waiting_for_customer: "bg-violet-100 text-violet-700", resolved: "bg-emerald-100 text-emerald-700",
  closed: "bg-slate-200 text-slate-600", pending: "bg-amber-100 text-amber-700", completed: "bg-emerald-100 text-emerald-700",
};

export function StatusBadge({ status, testid }) {
  const s = (status || "none").toLowerCase();
  return (
    <span data-testid={testid} className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold capitalize ${STATUS_STYLES[s] || "bg-slate-100 text-slate-600"}`}>
      {(status || "none").replace(/_/g, " ")}
    </span>
  );
}

export const CHART_COLORS = ["#2563eb", "#6366f1", "#0ea5e9", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#14b8a6"];
